import Vue from 'vue'
const state = {
    visit: {},    
    noBlinkVisits: []
};


const actions = {
    saveVisit({ commit }, payload) {
        commit('updateVisit', payload);
    },
    saveNoBlinkVisits({commit},payload)
    {
        commit('updateBlinkVisits',payload)
    }
};

const mutations = {
    updateVisit(state, payload) {
        state.visit = payload;
        
    },
    updateBlinkVisits(state,payload)
    {        
        Vue.set(state, 'noBlinkVisits', [...payload]);
    }
};

export const visits = {
    namespaced: true,
    state,
    actions,
    mutations
};
